import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  TextField,
  Typography
} from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'
import React, { useEffect } from 'react'
import { IMaskInput } from 'react-imask'
import {
  sendParameters,
  sendParametersForEdit
} from '../../../common/functions'
import FileUpload from '../../../components/file/FileUpload'
import FileViewWidget from '../../../components/file/FileView'
import TaskWrapper from './TaskWrapper'
import PropTypes from 'prop-types'
import { isBoolean } from 'lodash'
import BillScanLink from '../../../components/BillScanLink'
import { TASK_TYPE } from '../../../common/constants'

const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props
  return (
    <IMaskInput
      {...other}
      mask="00БП-000000"
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  )
})
TextMaskCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}

export default function AdditionalBillingWidget({ task, isCanceled }) {
  const [needsAdditionalBill, setNeedsAdditionalBill] = React.useState(
    task.meta?.needsAdditionalBill || false
  )
  const [additionalBillNumber, setAdditionalBillNumber] = React.useState(
    task.meta?.additionalBillNumber || ''
  )
  const [editMode, setEditMode] = React.useState(
    !task.meta?.additionalBillNumber &&
      !isBoolean(task.meta?.needsAdditionalBill)
  )
  const [additionalBillDate, setAdditionalBillDate] = React.useState(
    task.meta?.additionalBillDate
      ? dayjs(task.meta?.additionalBillDate)
      : dayjs()
  )
  const [additionalBillSentDate, setAdditionalBillSentDate] = React.useState(
    task.meta?.additionalBillSentDate
      ? dayjs(task.meta?.additionalBillSentDate)
      : dayjs()
  )
  const [files, setFiles] = React.useState([])

  useEffect(() => {
    if (
      !task.meta?.additionalBillNumber &&
      !isBoolean(task.meta?.needsAdditionalBill)
    )
      return
    setEditMode(false)
  }, [task])

  let enabled =
    task.isActive && editMode && task?.accessFlags?.update && !isCanceled
  console.log('additionalBillDate - ', additionalBillDate)

  return (
    <TaskWrapper
      task={task}
      label="Отдел бух. учёта"
      isCanceled={isCanceled}
      disabled={!enabled}
      rightContent={
        !editMode &&
        task.isActive && (
          <Button size="small" onClick={() => setEditMode(true)}>
            Редактировать
          </Button>
        )
      }
      onSave={() => {
        if (!task.meta?.additionalBillNumber) {
          sendParameters(
            task.paidServiceId,
            task.id,
            {
              needsAdditionalBill,
              additionalBillNumber,
              additionalBillDate: additionalBillDate?.format
                ? additionalBillDate?.format('YYYY-MM-DD')
                : additionalBillDate,
              isAdditionalBillPaid: task.meta?.isAdditionalBillPaid,
              additionalBillSentDate: additionalBillSentDate?.format
                ? additionalBillSentDate.format('YYYY-MM-DD')
                : additionalBillSentDate
            },
            files
          )
        } else {
          sendParametersForEdit(
            task.paidServiceId,
            task.id,
            {
              needsAdditionalBill,
              additionalBillNumber,
              additionalBillDate: additionalBillDate?.format
                ? additionalBillDate?.format('YYYY-MM-DD')
                : additionalBillDate,
              isAdditionalBillPaid: task.meta?.isAdditionalBillPaid,
              additionalBillSentDate: additionalBillSentDate?.format
                ? additionalBillSentDate.format('YYYY-MM-DD')
                : additionalBillSentDate
            },
            files
          )
        }
      }}
    >
      <Box display="flex" flexDirection="column" gap={3}>
        <FormControlLabel
          control={
            <Checkbox
              disabled={!enabled}
              value={needsAdditionalBill}
              checked={needsAdditionalBill}
              onChange={(e) => setNeedsAdditionalBill(e.target.checked)}
            />
          }
          label="Требуется доп. счёт"
        />
        {needsAdditionalBill && (
          <>
            <Box display="flex" flexDirection="column">
              <Typography variant="subtitle1" color="black">
                Дополнительный счёт:
              </Typography>
              <Box display="flex" justifyContent="space-between" gap={1}>
                <TextField
                  disabled={!enabled}
                  placeholder={'00БП-000000'}
                  variant="outlined"
                  label="Номер"
                  value={additionalBillNumber}
                  InputProps={{
                    inputComponent: TextMaskCustom
                  }}
                  onChange={(e) => setAdditionalBillNumber(e.target.value)}
                  required
                />
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Дата"
                    disabled={!enabled}
                    inputFormat="DD.MM.YYYY"
                    value={additionalBillDate}
                    onChange={(newValue) => {
                      setAdditionalBillDate(newValue?.format('YYYY-MM-DD'))
                    }}
                    renderInput={(params) => <TextField required {...params} />}
                  />
                </LocalizationProvider>
              </Box>
            </Box>

            <Box display="flex" flexDirection="column">
              <Typography variant="subtitle1" color="black">
                Дата отправки доп. счёта:
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  disabled={!enabled}
                  inputFormat="DD.MM.YYYY"
                  value={additionalBillSentDate}
                  onChange={(newValue) => {
                    setAdditionalBillSentDate(newValue?.format('YYYY-MM-DD'))
                  }}
                  renderInput={(params) => <TextField required {...params} />}
                />
              </LocalizationProvider>
            </Box>
            {task.meta?.isAdditionalBillPaid !== undefined && (
              <Typography
                variant="subtitle1"
                color={task.meta?.isAdditionalBillPaid ? 'green' : 'red'}
              >
                Доп счёт{' '}
                {task.meta?.isAdditionalBillPaid ? 'оплачен' : 'не оплачен'}
              </Typography>
            )}
            {task.meta?.isAdditionalBillPaid && (
              <Box display="flex" flexDirection="column" gap={1}>
                <BillScanLink
                  fileId={task.meta?.additionalBillFileId}
                  taskId={task.id}
                  taskTypeId={TASK_TYPE.ADDITIONAL_BILLING}
                  billNumber={task.meta?.additionalBillNumber}
                  billDate={task.meta?.additionalBillDate}
                  label="Скан доп. счёта"
                />
              </Box>
            )}
          </>
        )}
      
       {task?.isActive && !task?.payment_deadline_is_over && <FileUpload
                files={files}
                onUpload={(file) => setFiles([...files, file])}
                onDelete={(id) => setFiles(files.filter((file) => file.id !== id))}/>}
        <FileViewWidget files={task.files} />
      </Box>
    </TaskWrapper>
  )
}
